import React from 'react';
import { useState } from 'react';

const SvgIconButton = ({
  icon,
  color,
  width,
  height,
  marginLeft,
  marginRight,
  onClick,
  link,
  theme,
}) => {
  const iconStyle = {
    width: width || '24px',
    height: height || '24px',
    marginLeft: marginLeft || '0',
    marginRight: marginRight || '0',
  };

  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <>
      {link && (
        <a href={link} target='_blank' rel='noopener noreferrer'>
          <svg
            viewBox='0 0 24 24'
            fill={
              isHovering && color && theme
                ? theme.darkColor
                : color || 'currentColor'
            }
            style={iconStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <path d={icon} />
          </svg>
        </a>
      )}
      {!link && (
        <svg
          onClick={onClick}
          viewBox='0 0 24 24'
          fill={
            isHovering && color && theme
              ? theme.darkColor
              : color || 'currentColor'
          }
          style={iconStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <path d={icon} />
        </svg>
      )}
    </>
  );
};

export default SvgIconButton;
